/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { PageFhirType } from '../sharedcomponents/algorithm/types';

/** Just a dummy for webclient */
export const FhirSidebarInnerFlippable = undefined as ((x: any) => JSX.Element) | undefined;

export const defaultPageFhir: PageFhirType = {
  idsToFhir: {},
};

export default FhirSidebarInnerFlippable;
